import React, {Component, ReactNode} from 'react';
import I18n from 'app/i18n';
import {inject, observer} from 'mobx-react';
import {BetSlipStore} from 'app/store/BetSlipStore';
import BetSlipController from 'app/components/bet_slip/BetSlipController';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';

interface BetSlipStatsInterface {
    betSlipStore?: BetSlipStore
    controller?: BetSlipController
}

@inject('betSlipStore', 'controller')
@observer

export default class BetSlipStats extends Component<BetSlipStatsInterface> {
    statsLineKey: string = null;

    statsRequestId = 0;

    componentDidMount(): void {
        this.loadStatsLink();
    }

    componentDidUpdate(): void {
        const {bet: {selectedLine}} = this.props.controller;
        const statsLineKey = selectedLine
            ? `${selectedLine.id}-${Boolean(selectedLine.has_scoreboard)}-${Boolean(selectedLine.live)}`
            : null;

        if (statsLineKey !== this.statsLineKey) {
            this.loadStatsLink();
        }
    }

    componentWillUnmount():void {
        this.props.betSlipStore.switchShowStatsLink(false);
        this.props.betSlipStore.setStatsLink('');
    }

    showStats = (): void => {
        if (this.props) {
            const showScoreboard = !this.props.betSlipStore.showStatsLink;
            this.props.betSlipStore.switchShowStatsLink(showScoreboard);
        }
    };

    showText = (): string => this.props.betSlipStore.showStatsLink ? I18n.t('betslip_stats_hide') : I18n.t('betslip_stats_show');

    loadStatsLink = (): void => {
        const {bet: {selectedLine}} = this.props.controller;
        const requestId = this.statsRequestId + 1;

        this.statsRequestId = requestId;
        this.statsLineKey = selectedLine
            ? `${selectedLine.id}-${Boolean(selectedLine.has_scoreboard)}-${Boolean(selectedLine.live)}`
            : null;
        this.props.betSlipStore.switchShowStatsLink(false);
        this.props.betSlipStore.setStatsLink('');

        if (!selectedLine || !selectedLine.has_scoreboard || !selectedLine.live) {
            return;
        }

        this.props.controller.makeLinkRequest(selectedLine.id).then(statsLink => {
            const {bet: {selectedLine: currentSelectedLine}} = this.props.controller;

            if (this.statsRequestId !== requestId || currentSelectedLine?.id !== selectedLine.id) {
                return;
            }

            this.props.betSlipStore.setStatsLink(statsLink);
        });
    };

    render(): ReactNode {
        const {bet: {selectedLine}} = this.props.controller;
        const {statsLink} = this.props.betSlipStore;

        return selectedLine && selectedLine.has_scoreboard && selectedLine.live && statsLink
            ? <>
                <div className="bet-slip-line-description middle-icon">
                    <SpriteIcon name="#svg-round-warning" className="svg-default" />
                    <div>
                        <a onClick={this.showStats}>{this.showText()}</a>
                    </div>
                </div>
                {statsLink && this.props.betSlipStore.showStatsLink && <div className="bet-slip-stats">
                    <iframe width={'100%'} src={statsLink}/>
                </div>}
            </>
            : <></>;
    }
}
